import { TaxonomyTypes } from 'constants/categories'
import { useCategories } from 'hooks/data/useCategories'
import { useTags } from 'hooks/data/useTags'
import { useTaxonomies } from 'hooks/useTaxonomies'
import { useMemo } from 'react'

export const useFilters = auction => {
  const { categories } = useCategories()
  const { tags } = useTags()
  const auctionCategories = useMemo(() => {
    if (!auction?.categories) return []

    return auction.categories.map(({ id }) => id)
  }, [auction])

  const categoryOptions = useMemo(
    () =>
      getAuctionCategoriesWithChildren(
        categories
          .filter(({ id }) => auctionCategories.includes(id))
          .sort((a, b) => {
            return (
              auction?.categories?.find(({ id }) => id === a.id)?.index -
              auction?.categories?.find(({ id }) => id === b.id)?.index
            )
          })
      ),
    [categories, auctionCategories, auction?.categories]
  )
  const tagOptions = useMemo(() => tags.map(({ label, id }) => ({ label, value: id })), [tags])
  const materials = useTaxonomies(TaxonomyTypes.MATERIAL)
  const conditions = useTaxonomies(TaxonomyTypes.CONDITION)
  const rulers = useTaxonomies(TaxonomyTypes.RULER)
  const countries = useTaxonomies(TaxonomyTypes.COUNTRY)

  const filters = useMemo(
    () => ({
      categoryOptions,
      tagOptions,
      materials,
      conditions,
      rulers,
      countries,
    }),
    [categoryOptions, tagOptions, materials, conditions, rulers, countries]
  )

  return filters
}

const getAuctionCategoriesWithChildren = (auctions, auctionId = null) =>
  auctions
    .filter(({ parentId = null }) => parentId === auctionId)
    .map(({ label, id }) => ({ label, value: id, children: getAuctionCategoriesWithChildren(auctions, id) }))
